import { useState, useEffect } from 'react';
import api from '../lib/api';

const DEFAULTS = {
  razon_social: 'CHIRINO STEEL ING. Y CONT. SPA',
  rut: '76.738.421-1',
  direccion: 'RUTA 5 SUR KM 1032, PARCELA 2',
  giro: 'INGENIERIA Y CONSTRUCCION',
  slogan: 'Ingenieria - Fabricacion - Montaje',
};

let _cache = null;

export function useEmpresa() {
  const [empresa, setEmpresa] = useState(_cache || DEFAULTS);

  useEffect(() => {
    if (_cache) return;
    api.get('/config/empresa')
      .then(res => {
        const data = { ...DEFAULTS, ...res.data };
        _cache = data;
        setEmpresa(data);
      })
      .catch(() => {});
  }, []);

  return empresa;
}
